import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { LiquidacionesComponent } from './Liquidaciones.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'Liquidaciones',
        component: LiquidacionesComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Liquidaciones',
          nombreFormulario : 'Liquidaciones'
        } 
    }
];

@NgModule({
    declarations: [
        LiquidacionesComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        LiquidacionesComponent
    ]
})

export class LiquidacionesModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Liquidaciones/Liquidaciones.module.ts